export const stats = {
  table: {
    field: {
      campaign: 'Kampanye',
      campaign_id: 'Campaign ID',
      task_number: 'Jumlah Task',
      src: 'Caller ID',
      dst: 'Jumlah',
      task_id: 'ID Tugas',
      date_time: 'Tanggal and waktu',
      duration: 'Durasi',
      cost: 'Biaya',
      status: 'Status',
      call_date: 'Dimulai pada',
      progress_date: 'Diinisialisasi pada',
      answer_date: 'Dijawab pada',
      connection_date: 'Tersambung ke operator di',
      end_date: 'Telepon diakhiri pada',
      recording: 'Rekaman panggilan',
      hangup_cause: 'Hangup Cause Code',
      queue_time: ' Durasi penundaan setelah memutar nomor',
      pdd: 'Durasi menunggu tanggapan operator',
      duration_billed: 'Durasi percakapan',
      campaign_name: 'Nama kampanye',
      type: 'Jenis mesin penjawab',
      disconnection: 'Pemisahan',
      amd_result: 'Kemungkinan'
    }
  },

  filter: {
    status: '@:autocaller_v2.stats.table.field.status',
    task_number: '@:autocaller_v2.stats.table.field.task_number',
    src: '@:autocaller_v2.stats.table.field.src',
    dst: '@:autocaller_v2.stats.table.field.dst'
  },

  state: {
    ANSWERED: 'Terjawab',
    NO_ANSWER: 'Tidak terjawab',
    REJECTED: 'Ditolak',
    ERROR: 'Gagal'
  }
};
